module.exports = __webpack_public_path__ + "img/nikko-80s.7892a90.jpg";